<template>
  <v-layout wrap>
    <v-flex sm12>
      <v-toolbar dense ref="aToolbar" flat>
        <v-toolbar-title>
          {{ $t('MERGE_PANEL_TITLE') }}
          <span class="subheading">({{ $t('MERGE_NUMBER_INCLUDED', [selectedContacts.length - excluded.length]) }})</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn :disabled="!master.id" @click="onMergeContacts()">{{ $t('MERGE_BUTTON_EXECUTE') }}</v-btn>
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug" absolute- right- ><v-icon>mdi-bug-outline</v-icon></v-btn>
        <v-toolbar-items >
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>
    <v-flex sm12 v-if="debug">
      {{ exportIds }}
      <v-divider />
      {{ selectedContacts }}
      <v-divider />
      {{ data.fields }}
      <v-divider />
      {{ data.custom_fields }}
      <v-divider />
      {{ availableFields }}
    </v-flex>
    <v-flex sm12 v-if="debug">
      {{ master }}
      <v-divider />
      {{ selected }}
      <v-divider />
      {{ excluded }}
      <v-divider />
      {{ mergeResult }}
    </v-flex>
    <v-flex sm12 v-if="selectedContacts.length && excluded.length >= selectedContacts.length - 1">
      <v-alert type="warning" :value="true">
        <h4>{{ $t('MERGE_MINIMUM_TITLE') }}</h4>
        <p>{{ $t('MERGE_MINIMUM_TEXT') }}</p>
      </v-alert>
    </v-flex>
    <v-flex sm12 v-else>
      <v-alert type="info" v-if="!master.id" :value="true">
        <h4>{{ $t('MERGE_STEP1_TITLE') }}</h4>
        <p>{{ $t('MERGE_STEP1_TEXT') }}</p>
      </v-alert>
      <v-alert type="info" v-else :value="true">
        <h4>{{ $t('MERGE_STEP1_TITLE') }}</h4>
        <p>{{ $t('MERGE_STEP2_TEXT') }}</p>
      </v-alert>
      <v-alert
        v-model="alert.show"
        border="left"
        close-text="Close Alert"
        color="orange accent-4"
        dark
        dismissible
      >
      <h4>{{ $t('ERROR_HEADING') }}</h4>
      <p>{{ alert.msg }}</p>
     </v-alert>
    </v-flex>
    <v-flex sm12>

      <v-container>
        <v-card>
          <v-card-text>
            {{$t('MERGE_MULTICAT_INTRO')}}
          <v-radio-group
            v-model="mergeType"
            row
          >
            <v-radio
              :label="$t('MERGE_MULTICAT_JOIN')"
              value="join"
            ></v-radio>
            <v-radio
              :label="$t('MERGE_MULTICAT_MASTER')"
              value="master"
            ></v-radio>
          </v-radio-group>
          {{$t('MERGE_NUMBER_INCLUDED', [selectedContacts.length - excluded.length])}}
      <v-layout>
        <v-flex>
          <v-data-table
            :items="availableGridFields"
            class="elevation-1 contactmerge"
            :items-per-page="-1"
            hide-default-header
            hide-default-footer
            fixed-header
          >
            <template v-slot:header="">
              <tr>
                <th class="fixed"></th>
                <th class="fixed">{{ $t('MERGE_RESULT_TITLE') }}</th>
                <th
                  v-for="contact in selectedContacts"
                  :key="contact.id"
                >
                  {{ contact.accountName ? contact.accountName : $t('MERGE_NO_ACCOUNT') }}<br />
                  {{ contact.pubLoginDateTime ? $moment(contact.pubLoginDateTime).format($t('LOCALE_DATETIME_FORMAT')) : $t('MERGE_NO_LOGIN') }}<br />
                  <v-btn icon class="contacts" :title="$t('MERGE_BUTTON_MASTER')" :disabled="isExcluded(contact)" @click="onMaster(contact)"><v-icon v-if="isMaster(contact)">mdi-star-circle</v-icon><v-icon v-else>mdi-star-circle-outline</v-icon></v-btn>
                  <v-btn icon class="contacts" :title="$t('MERGE_BUTTON_EXCLUDE')" @click="onExclude(contact)"><v-icon v-if="isExcluded(contact)">mdi-close-circle</v-icon><v-icon v-else>mdi-close-circle-outline</v-icon></v-btn>
                </th>
              </tr>
            </template>

            <template v-slot:item="props">
              <tr>
                <td class="fixed"><b>{{ props.item.label }}</b></td>
                <td class="fixed">
                  <div label class="merge_field" >
                    <template v-if="props.item.type === 'field'">{{ mergeResult[props.item.id] }}</template>
<!--                    <template v-if="props.item.type === 'category'">-->
<!--                      <span v-html="mergeResult[props.item.id] ? props.item.children.filter(a => mergeResult[props.item.id].includes(a.id)).map(a => a.name).join('<br />') : ''">-->
<!--                      </span>-->
<!--                    </template>-->
                    <template v-if="props.item.type === 'free'">{{ mergeResult[props.item.id] }}</template>
                  </div>

                </td>
                <td
                  v-for="contact in selectedContacts"
                  :key="contact.id"
                >
                  <div label :class="isSelected(contact, props.item) ? 'chip_active' : ''" @click="onSelect(contact, props.item)">
                    <template v-if="props.item.type === 'field'">{{ guardedFieldName(contact[props.item.field]) }}</template>
<!--                    <template v-if="props.item.type === 'category'"><span class="chip_span" v-html="contact.categories[props.item.value] ? props.item.children.filter(a => contact.categories[props.item.value].includes(a.id)).map(a => a.name).join('<br />') : ''"></span></template>-->
                    <template v-if="props.item.type === 'free'">{{ guardedFieldName(contact.customFields[props.item.value]) }}</template>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-container>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Contact from "../services/Contact";
// import Search from '../services/Search'

// import ContactModel from '../models/ContactModel'

export default {
  name: 'ContactsMerge',
  props: ['refToolbar'],
  data() {
    return {
      debug: false,
      alert: {
        show: false,
        msg: '',
      },
      master: {},
      excluded: [],
      selected: {},
      mergeType: 'join',
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'data', 'getCustomFieldById', 'selectedItems', 'selectedContacts', 'allToExport', 'contactsTotal', 'searchReq', 'exportIds']),
    numSelected() {
      return this.allToExport ? this.contactsTotal - this.exportIds.length : this.exportIds.length
    },
    numTotal() {
      return this.contactsTotal
    },
    availableGridFields() {
      return this.availableFields.filter(f => f.type != 'category')
    },
    availableFields() {
      let availableFields = []
      if (this.selectedContacts.length) {
        // get all mergable and has value on data fields
        availableFields = availableFields.concat(this.data.fields.filter(a => a.mergeable).filter(a => this.selectedContacts.map(b => b[a.field]).filter(Boolean).length))
        availableFields = availableFields.filter(a=> this.selectedContacts.map(b=> b[a.field]).some(val => val))
        // availableFields = availableFields.filter(a=> !this.selectedContacts.map(b=> b[a.field]).every((val,i,arr)=> val==arr[0])) -- filter only those that are equal

        let avCategories = this.data.categories.filter(a => this.selectedContacts.filter(b => b.categories[a.id]).length).map(a => ({ ...a, id: `cat_${a.id}`, type: 'category' }))
        availableFields = availableFields.concat(avCategories)

        let avFreeFields =  this.data.custom_fields.filter(a => this.selectedContacts.filter(b => b.customFields[a.id]).length).map(a => ({ ...a, id: `free_${a.id}` }))
        // avFreeFields = avFreeFields.filter(a=> !this.selectedContacts.map(b=> b.customFields[a.value]).every((val,i,arr)=> val==arr[0]))
        avFreeFields = avFreeFields.filter(a=> this.selectedContacts.map(b=> b.customFields[a.value]).some(val => val))
        availableFields = availableFields.concat(avFreeFields)
      }
      availableFields = availableFields.filter(a => a.datatype !== 'checkbox')
      return availableFields
    },
    mergeResult() {
      let result = {}
      const self = this
      this.availableFields.forEach(a => {
        if (this.selected[a.id]) {
          const contact = this.selectedContacts.find(b => b.id === this.selected[a.id])
          if (contact) {
            if (a.type === 'field') {
              result[a.id] = contact[a.field]
            }
            if (a.type === 'category') {
              // result[a.id] = a.children.filter(b => contact.categories[a.value] && contact.categories[a.value].includes(b.id)).map(a => a.name).join('<br />')
              if (a.multiple == '1' && self.mergeType == 'join') {
                const sources = self.selectedContacts.filter(b => b.id !== self.selected[a.id])
                // console.log('sources:', sources)
                let scats = a.children.filter(b => contact.categories[a.value] && contact.categories[a.value].includes(b.id)).map(a => a.id)
                // console.log('master - scats:', scats)
                sources.forEach(s => {
                  scats = scats.concat(a.children.filter(b => s.categories[a.value] && s.categories[a.value].includes(b.id)).map(a => a.id))
                  // console.log('scats:', scats)
                })
                result[a.id] = [...new Set(scats)]
                // console.log('result_new merge categ:', result[a.id])
              } else {
                result[a.id] = a.children.filter(b => contact.categories[a.value] && contact.categories[a.value].includes(b.id)).map(a => a.id)
              }
            }
            if (a.type === 'free') {
              result[a.id] = contact.customFields[a.value]
            }
          }
        }
      })
      return result
    },
  },

  watch: {
  },

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)

    let ids = this.selectedItems.map(a => a.id);
    ids = ids.join(',');
    new Contact(this.$api).loadSelected(ids)
  },

  methods: {
    guardedFieldName(name) {
        return name? name : '-----'
    },
    onMergeContacts() {
      this.alert.show = false
      this.selectedContacts.forEach((contact) => {
        console.log('contact.isMaster:', this.isMaster(contact), contact)
      })
      console.log('this.mergeResult:', this.mergeResult)
      // targetContact, sourceContacts, mergeResult
      const targetContact = this.selectedContacts.find((contact) => this.isMaster(contact))
      const sourceContacts = this.selectedContacts.filter((contact) => !this.isMaster(contact))
      new Contact(this.$api).merge(targetContact, sourceContacts, this.mergeResult)
      .then (result => {
        console.log('onMergeContacts.res:', result)
        if (result && result.status && result.status=='error') {
          this.alert.show = true
          this.alert.msg = result.reason.split('! at /')[0]+'!'
        } else {
          this.$router.go(-1)
        }
      })
    },
    onMaster(contact) {
      if (!this.isExcluded(contact)) {
        this.master = contact
        let that = this,
          selected = this.selected
        this.availableFields.forEach(a => {
          that.$set(selected, a.id, contact.id)
        })
      }
    },
    isMaster(contact) {
      return this.master && contact && this.master.id === contact.id
    },
    onExclude(contact) {
      let idx = this.excluded.map(a => a.id).indexOf(contact.id)
      if (idx >= 0) {
        this.excluded.splice(idx, 1)
      } else {
        this.excluded.push(contact)
        if (this.isMaster(contact)) {
          this.master = {}
          this.selected = {}
        } else {
          let that = this,
            selected = this.selected
          this.availableFields.forEach(a => {
            if (selected[a.id] === contact.id) {
              if (this.master && this.master.id) {
                that.$set(selected, a.id, this.master.id)
              } else {
                that.$delete(selected, a.id, contact.id)
              }
            }
          })
        }
      }
    },
    isExcluded(contact) {
      return this.excluded.map(a => a.id).includes(contact.id)
    },
    onSelect(contact, field) {
      if (!this.isExcluded(contact)) {
        let selected = this.selected
        this.$set(selected, field.id, contact.id)
      }
      if (!this.master.id) {
        this.$store.commit('showMessage', {
          title: this.$t('MERGE_STEP1_TITLE'),
          content: this.$t('MERGE_STEP1_TEXT'),
          color: 'orange'
        })
      }
    },
    isSelected(contact, field) {
      return this.selected[field.id] === contact.id
    },
  },
  beforeDestroy() {
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>
.section {
  margin-top: 50px
}
th.fixed,
td.fixed {
  /* display: flex;
  position: absolute;
  width: 200px; */
}
.chip_active{
  padding: 5px;
  background: rgba(51,153,0,.25);
  border: 1px solid darkgray;
  border-radius: 5px;
}
.chip_span{
  /* padding: 5px; */
}
.merge_field{
  padding: 5px;
}

.contacts{
  margin: 5px;
}

.contactmerge > .v-data-table__wrapper{height:calc(100vh - 370px) !important;}

</style>
